import { useState } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import { Stack, Typography } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import FormControlLabel from '@mui/material/FormControlLabel';

// ----------------------------------------------------------------------

export default function TablePaginationCustom({
  dense,
  onChangeDense,
  customRowsPerPage,
  rowsPerPageOptions = [1, 5, 10, 25, 50],
  sx,
  identifier,
  ...other
}) {
  const [rowsPerPage, setRowsPerPage] = useState(customRowsPerPage || 25);

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    sessionStorage.setItem(`rowsPerPage_${identifier}`, newRowsPerPage);
    if (other.onRowsPerPageChange) {
      other.onRowsPerPageChange(event);
    }
  };

  return (
    <Stack direction="row" justifyContent={other?.count === 0 ? 'space-between' : 'flex-end'}>
      {other?.count === 0 && (
        <Stack
          width="fit-content" py={1} px={3} direction="column" alignItems="flex-start">
          <Typography variant="body2" color="text.secondary">
            🔍 No results found
          </Typography>
          <Typography variant="caption" color="text.disabled" textAlign="center">
            Try adjusting your search or filters to find what you’re looking for.
          </Typography>
        </Stack>
      )}
      <Box sx={{ position: 'relative', ...sx }}>
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          {...other}
          rowsPerPage={rowsPerPage}
          onPageChange={other.onPageChange}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTopColor: 'transparent',
          }}
        />

        {onChangeDense && (
          <FormControlLabel
            label="Dense"
            control={<Switch checked={dense} onChange={onChangeDense} />}
            sx={{
              pl: 2,
              py: 1.5,
              top: 0,
              position: {
                sm: 'absolute',
              },
            }}
          />
        )}
      </Box>
    </Stack>
  );
}

TablePaginationCustom.propTypes = {
  dense: PropTypes.bool,
  onChangeDense: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  sx: PropTypes.object,
  customRowsPerPage: PropTypes.arrayOf(PropTypes.number),
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  identifier: PropTypes.string, // Unique identifier for this table
};
